var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51841 7.46161C1.88639 6.35958 1.58123 5.45969 1.39722 4.54752C1.12508 3.19843 1.74787 1.88058 2.77958 1.03969C3.21563 0.684296 3.71548 0.805719 3.97333 1.26831L4.55545 2.31265C5.01685 3.14042 5.24756 3.5543 5.2018 3.9931C5.15604 4.4319 4.84491 4.78928 4.22264 5.50404L2.51841 7.46161ZM2.51841 7.46161C3.79767 9.69222 5.80522 11.7009 8.03842 12.9816M8.03842 12.9816C9.14046 13.6136 10.0403 13.9188 10.9525 14.1028C12.3016 14.375 13.6195 13.7522 14.4603 12.7205C14.8157 12.2844 14.6943 11.7846 14.2317 11.5267L13.1874 10.9446C12.3596 10.4832 11.9457 10.2525 11.5069 10.2982C11.0681 10.344 10.7108 10.6551 9.99599 11.2774L8.03842 12.9816Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.335818b2af93ca7407f297af2154c3fb.svg";
export { ForwardRef as ReactComponent };